module.exports = "//static.hsappstatic.net/salesImages/static-1.403/icons/office365-logo.png"